import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9.64062 1.875C13.9291 1.8752 17.4053 5.35211 17.4053 9.64062C17.4052 11.3903 16.8271 13.0053 15.8506 14.3037L17.8701 16.3232C18.2972 16.7504 18.2972 17.443 17.8701 17.8701C17.443 18.2972 16.7504 18.2972 16.3232 17.8701L14.3037 15.8496C13.0053 16.8262 11.3904 17.4052 9.64062 17.4053C5.35211 17.4053 1.8752 13.9291 1.875 9.64062C1.875 5.35199 5.35199 1.875 9.64062 1.875ZM9.64062 4.0625C6.56011 4.0625 4.0625 6.56011 4.0625 9.64062C4.0627 12.721 6.56023 15.2178 9.64062 15.2178C11.1284 15.2177 12.4805 14.635 13.4805 13.6855C13.5096 13.6475 13.5414 13.6109 13.5762 13.5762C13.6109 13.5414 13.6476 13.5096 13.6855 13.4805C14.6349 12.4805 15.2177 11.1283 15.2178 9.64062C15.2178 6.56023 12.721 4.0627 9.64062 4.0625Z"
	})
});
export default SvgSearch;
